import './less/TwoFactorVerification.less';
import './less/TwoFactorIcons.less';

import clsx from 'clsx';
import React from 'react';
import { Button } from '../button/Button';
import { dispatch } from 'nike-re-framejs';
import { TwoFactorFailedIcon } from '../../icons/TwoFactorFailedIcon';
import { restart2FA } from './index';
import ButtonRow from '../button/ButtonRow';
import i18n from '../../common/i18n';

const TwoFactorVerFailed = ({ error, onClose, portal }) => {
    return (
        <div
            className={clsx('two-factor-ver-box', {
                'two-factor-ver-box-padding': portal
            })}
        >
            <TwoFactorFailedIcon />
            <h1 className="two-factor-ver-title">{i18n('nui.two.fa.failed.verification.title')}</h1>
            <h3 className="two-factor-ver-description">{i18n(`nui.2fa.code.${error}`)}</h3>
            <ButtonRow className="two-factor-buttons full-width">
                <Button className="grey" large onClick={onClose} label={i18n('nui.button.cancel')} />
                <Button primary large onClick={() => dispatch(restart2FA())} label={i18n('nui.button.retry')} />
            </ButtonRow>
        </div>
    );
};

export default TwoFactorVerFailed;
